<template>
  <div class="department-tree-card d-flex align-items-center">
    <div
      class="drag-handle-container mr-1"
      @click.stop
      @mousedown="$emit('mousedown', $event)"
      @mouseup="$emit('mouseup', $event)"
    >
      <Icon name="drag_handle_icon" />
    </div>
    <div class="expansion-icon-container mr-1" @click.stop="toggleExpansion">
      <EXTooltip
        v-if="expansionState === 'No Expand'"
        class="no-subdepartments-tooltip"
        data-testid="no-subdepartments-tooltip"
        placement="top"
        :title="NO_SUBDEPARTMENTS_TOOLTIP"
        :delay="200"
      >
        <TreeExpansionIcon :state="expansionState" />
      </EXTooltip>
      <TreeExpansionIcon v-else :state="expansionState" />
    </div>
    <div class="org-object-card-container">
      <OrgObjectCard
        :type="type"
        :codeValue="code"
        :name="name"
        :icon="true"
        :allow_hover="false"
        :showTooltip="true"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import Icon from '@components/icons/Icon.vue';
import TreeExpansionIcon from '@components/TreeExpansionIcon/TreeExpansionIcon.vue';
import OrgObjectCard from '@components/OrgObjectCard/OrgObjectCard.vue';
import EXTooltip from '@components/tooltip/EXTooltip.vue';

const NO_SUBDEPARTMENTS_TOOLTIP = 'No subdepartments';

const props = defineProps({
  state: {
    type: String,
    required: true,
    validator: (value) => ['Collapsed', 'Expanded', 'No Expand'].includes(value),
  },
  code: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'department',
  },
});

const expansionState = ref(props.state);

watch(() => props.state, (newVal) => {
  expansionState.value = newVal;
});

const emit = defineEmits(['update:state', 'toggle', 'mousedown', 'mouseup']);

const toggleExpansion = () => {
  if (expansionState.value === 'No Expand') return;
  expansionState.value = expansionState.value === 'Collapsed' ? 'Expanded' : 'Collapsed';
  emit('update:state', expansionState.value);
  emit('toggle', expansionState.value);
};
</script>

<style scoped>
.department-tree-card {
  width: 100%;
  min-width: 0;
}
.org-object-card-container {
  flex: 1;
  min-width: 0;
  max-width: 100%;
}
.drag-handle-container {
  cursor: grab;
  color: #98A2B3;
}
.drag-handle-container:active {
  cursor: grabbing;
}
.expansion-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
::v-deep .org-object-card-compass {
  padding: 0 3px !important;
}
::v-deep .org-object-card-compass.clickable:hover {
  padding: 0 !important;
}
</style>
